import {alpha, styled} from "@mui/material/styles";
import {Switch} from "@mui/material";

const OrangeSwitch = styled(Switch)(({theme}) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: '#FF6600',
        '&:hover': {
            backgroundColor: alpha('#FF6600', theme.palette.action.hoverOpacity),
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: '#FF6600',
    },
}));

export default OrangeSwitch;